import { Dialog, GenericSuspense, useUrlParamsValueToString } from '@bsm/component';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useInvoiceDetailsQuery } from '../hooks/useInvoiceDetailsQuery';
import InvoiceSignatoryDetails from '../components/InvoiceSignatoryDetails';

export default function SignatureDetailsContainer() {
    const navigate = useNavigate();
    const { id } = useParams();
    const urlParams = useUrlParamsValueToString();
    const { data } = useInvoiceDetailsQuery(parseInt(id), true);
    
    return (
        <>
            <Dialog
                open
                title={data?.name}
                onClose={() => navigate(`..?${urlParams}`)}
            >
                <InvoiceSignatoryDetails {...data} />
            </Dialog>
            
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </>
    );
}
